
import { getIsLoggingEnabled } from "./StateManagement";

// Writes a log row directly to the "DR Log" sheet in Excel
export async function writeLogToDRLogSheet(logRow: string[]) {
  // Only create or write to the sheet if logging is enabled
  if (!getIsLoggingEnabled()) return;
  try {
    await Excel.run(async (context) => {
      let sheet;
      try {
        sheet = context.workbook.worksheets.getItem("DR Log");
      } catch {
        // Only create the sheet if logging is enabled (already checked above)
        sheet = context.workbook.worksheets.add("DR Log");
      }
      const usedRange = sheet.getUsedRangeOrNullObject();
      usedRange.load("rowCount");
      await context.sync();

      const nextRow = usedRange.isNullObject ? 1 : usedRange.rowCount + 1;
      const colCount = logRow.length;
      const colEnd = String.fromCharCode(64 + colCount); // e.g., 'C' for 3 columns
      const logRange = sheet.getRange(`A${nextRow}:${colEnd}${nextRow}`);
      logRange.values = [logRow];
      await context.sync();
    });
  } catch (error) {
    console.log("Excel log error: " + error);
  }
}

export async function DRLog(level: string, message: string, addressComponents: string[] = []) {
  if (!getIsLoggingEnabled()) return; // Skip logging if disabled
  if (level === "DEBUG") return; // Skip DEBUG level logs

  const timestamp = new Date().toISOString();
  await writeLogToDRLogSheet([timestamp, level, "Functions", addressComponents[0] ?? "", addressComponents[1] ?? "", message]);
}
